/*
 * Copyright (c) 2020 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {dlsColor} from '../theme/theme';
import {IconProps} from '../types/types';
import useIconDLS from './useIconDLS';
import useIconSize from './useIconSize';

/*
 * Defines the Design Language System (DLS) Notification Time Icon component.
 */
export const NotificationTimeIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none'>
      <path d='M12 9V13.64L15.21 15.99'
        stroke={iconColor}
        strokeWidth={1.5}
        strokeMiterlimit={10}
        strokeLinecap='round' />
      <circle cx={12.5}
        cy={12.5}
        r={10.5}
        stroke={iconColor}
        strokeWidth={1.5} />
    </svg>
  );
};
